module.exports = __webpack_public_path__ + "img/almoosa-website.341a4e42.jpg";